import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-genesys-calls',
  templateUrl: './genesys-calls.component.html',
  styleUrls: ['./genesys-calls.component.scss']
})
export class GenesysCallsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
